module.exports = __webpack_public_path__ + "img/pic_10jifen3.27088aa9.png";